import React, {ErrorInfo} from 'react';
import {LOCAL_STORAGE_KEYS} from '~/lib/const';
import {Button, Text} from '~/components';
import navigation from '~/lib/navigation';

interface IProps {
  children: React.ReactNode;
}

interface IState {
  hasError: boolean;
  isErrorHappenedInInterval: boolean;
}

const MAX_PAGE_RELOAD_INTERVAL = 20; // 20 seconds

class ErrorBoundary extends React.Component<IProps, IState> {
  // @ts-ignore
  constructor(props) {
    super(props);
    this.state = {hasError: false, isErrorHappenedInInterval: false};
  }

  static getDerivedStateFromError(error: Error) {
    const now = Date.now();
    const previousErrorTimestamp = Number(
      localStorage.getItem(LOCAL_STORAGE_KEYS.PAGE_RELOAD_ON_ERROR_TIMESTAMP),
    );
    // If there is no error happened before or
    // if there is no error happened in the interval of MAX_PAGE_RELOAD_INTERVAL seconds
    // Reload the page and record the timestamp
    const isErrorHappenedInInterval =
      previousErrorTimestamp == null
        ? false
        : (now - previousErrorTimestamp) / 1000 < MAX_PAGE_RELOAD_INTERVAL;
    // Update state so the next render will show the fallback UI.
    return {hasError: true, isErrorHappenedInInterval};
  }

  // You can also log the error to an error reporting service
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const now = Date.now();
    if (!this.state.isErrorHappenedInInterval) {
      // Safari and Chrome might have different error messages;
      // This is needed for mostly errors on dynamically imported modules error.
      localStorage.setItem(
        LOCAL_STORAGE_KEYS.PAGE_RELOAD_ON_ERROR_TIMESTAMP,
        String(now),
      );
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      if (this.state.isErrorHappenedInInterval) {
        // You can render any custom fallback UI
        return (
          <div className={'w-screen'}>
            <div
              className={
                'max-w-6xl w-full flex flex-col justify-center items-center p-10 text-center mx-auto'
              }
            >
              <Text as={'h3'}>Something went wrong.</Text>
              <Text className={'mt-6 max-w-md'}>
                We found an error while loading this page. Please, refresh or go
                back to the home page.
              </Text>
              <Button
                className={'mt-4'}
                variant="blue"
                onClick={() =>
                  (window.location.href = navigation.homePage.getPath())
                }
              >
                Home Page
              </Button>
              <a
                className={'mt-4 text-primary'}
                href={'mailto:experts@skiessentials.com'}
              >
                Support: experts@skiessentials.com
              </a>
            </div>
          </div>
        );
      } else {
        // Reloading the page in here
        // see: componentDidCatch
        return null;
      }
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
